import { css, keyframes } from '@emotion/react';
import { theme } from '@frontend/theme';
import { TASK_HIGHLIGHT_DURATION } from '../../constants';

const highlightAnimation = keyframes`
  0% {
    background-color: ${theme.colors.warning5};
  }

  80% {
    background-color: ${theme.colors.warning5};
  }

  100% {
    background-color: transparent;
  }
`;

export const containerStyle = (showHighlight: boolean) => [
  css`
    padding: ${theme.spacing(2.5, 3, 3, 3)};
    gap: ${theme.spacing(1.5)};
    display: flex;
    flex-direction: column;
    border-bottom: 1px solid ${theme.colors.neutral20};
    position: relative;
    width: 100%;
    transition: background-color 0.2s ease-in-out;

    .row {
      display: flex;
      align-items: center;
      gap: ${theme.spacing(1)};

      .chip:nth-child(n + 3) {
        flex: 0 1 auto;
        min-width: 0;
      }
    }

    :hover {
      cursor: pointer;
      background-color: ${showHighlight ? theme.colors.warning5 : theme.colors.neutral5};
    }
  `,
  showHighlight &&
    css`
      animation: ${highlightAnimation} ${TASK_HIGHLIGHT_DURATION}ms ease-out forwards;
    `,
];

export const loaderStyles = css`
  inset: 0;
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${theme.colors.black};
  opacity: 0.3;
`;

export const dueDateChipStyle = css`
  color: ${theme.font.colors.default};
  font-weight: ${theme.font.weight.bold};
`;

export const taskTitleContainer = css`
  flex-grow: 1;
  flex-basis: 0;
  display: flex;
  gap: ${theme.spacing(1)};
  padding: ${theme.spacing(0.5, 0, 0, 0)};
`;

export const firstTaskItemRow = css`
  align-items: flex-start !important;
`;

export const callIntelIconStyle = (isAir: boolean) => css`
  color: var(--fabric-color-neutral-50);
  margin-top: ${isAir ? 'var(--fabric-space-gap-xxs)' : 'var(--fabric-space-gap-xs)'};
`;
